
export default function AboutSection() {
  return (
    <section id="sobre" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
            Sobre a <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">See Media</span>
          </h2>
          
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-blue-600 to-purple-600"></div>
            
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-8">
              A See Media nasceu para revolucionar o mercado de Digital Out-of-Home (DOOH). 
              Nossa tecnologia de Inteligência Artificial garante transparência, precisão e 
              resultados mensuráveis, entregando às marcas a oportunidade de impactar o público 
              certo, no momento certo.
            </p>
            
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-brain-line text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">IA Avançada</h3>
                <p className="text-gray-600">Tecnologia de ponta para análise inteligente</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-eye-line text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Precisão Total</h3>
                <p className="text-gray-600">Medição exata do engajamento visual</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-bar-chart-line text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">ROI Comprovado</h3>
                <p className="text-gray-600">Resultados mensuráveis e transparentes</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
